import { render, staticRenderFns } from "./wcrd_alchol_pawn.vue?vue&type=template&id=18881108&scoped=true&"
import script from "./wcrd_alchol_pawn.vue?vue&type=script&lang=js&"
export * from "./wcrd_alchol_pawn.vue?vue&type=script&lang=js&"
import style0 from "./wcrd_alchol_pawn.vue?vue&type=style&index=0&id=18881108&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18881108",
  null
  
)

export default component.exports